/**
 * Created by mnaughton on 9/30/2015.
 */

/**
 * A (backbone) collection of data type models.
 * @module app/models/DataTypeCollection
 */
import Backbone from "backbone";
import Layer from "app/models/Layer";
import _ from "underscore";
import urlService from "app/UrlService";
export default Backbone.Collection.extend({
  model: Layer,

  url: function () {
    var result;

    if (this.options.service) {
      result = urlService.apiurl(
        "/layers/byservice/" + this.options.service.id + "/layers"
      );
    } else {
      result = urlService.apiurl("/layers");
    }

    return result;
  },

  /**
   * Initializes this collection.
   * @param  {Array} models  Initial models for the collection.
   * @param  {object} options The options mapping.
   * @param {app/utils/UrlBuilder} options.urlBuilder The URL builder with which to construct the path.
   */
  initialize: function (models, options) {
    this.options = _.defaults({}, options);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/LayerCollection.js
// module id = 507
// module chunks = 1